import { Check, Copy } from 'lucide-react';
import React, { useEffect, useState } from 'react';

import { Button } from '@column/ui';

import { useNotificationStore } from '~/stores/Notification';
import { copyToClipboard } from '~/util';

const useCopy = (value: string) => {
  const { addDangerNotification } = useNotificationStore();
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const timeout = setTimeout(() => setCopied(false), 1500);
    return () => clearTimeout(timeout);
  }, [copied]);

  const copy = () =>
    void copyToClipboard(value)
      .then(() => setCopied(true))
      .catch(() => addDangerNotification({ content: 'Unable to copy to the clipboard' }));
  return { copied, copy };
};

const CopyIcon: React.FC<{ copied: boolean }> = ({ copied }) =>
  copied ? <Check className="text-green-600" /> : <Copy />;

export const CopyButton: React.FC<{ label: string; value: string }> = ({ label, value }) => {
  const { copied, copy } = useCopy(value);
  return (
    <Button
      type="button"
      variant="muted"
      size="icon-sm"
      aria-label={`Copy ${label}`}
      onClick={copy}
      className="text-gray-400 shadow-none hover:shadow-none dark:text-gray-500 dark:shadow-none"
    >
      <CopyIcon copied={copied} />
    </Button>
  );
};
